import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Button from '@material-ui/core/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';

import first from "assets/img/faces/first.png";
import second from "assets/img/faces/second.png";
import third from "assets/img/faces/third.png";
import other from "assets/img/faces/winner.png";
import validate from "assets/img/topdev-validate.jpg";


import styles from "assets/jss/material-kit-react/views/topdev.js";
import Axios from "axios";
import Config from "../../../config.js"
import swal from 'sweetalert'
import Ads from "../../Main/Sections/Ads2.js";



const useStyles = makeStyles(styles);

export default function UstmbJamMainPage(props) {
    const classes = useStyles();
    const [challenges, setChallenges] = useState(null);

    const { ...rest } = props;
    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );
    var next = (register, challengeId) => {
        props.history.push("/UstmbTopDev/Challenges/" + challengeId);
    }
    var start = (challengeId, index) => {
        if (!challenges[index].active) {
            return swal("تا شروع مسابقه صبر کنید.")
        }
        if (localStorage.getItem('token')) {
            Axios.post(Config.api + "Challenge/RegisterInChallenge", {
                challengeId: challengeId
            },
                {
                    headers: {
                        apikey: Config.apikey,
                        Authorization: "Bearer " + localStorage.getItem('token')

                    }
                }).then(async (result) => {
                    next(1, challengeId);
                }).catch((err) => {
                    console.log(err)
                    if (err && err.response && err.response.status && err.response.status === 401) {
                        swal("برای شروع مسابقه، باید وارد شوید.").then(() => {
                            localStorage.removeItem('token');
                            props.history.push("/SignIn");
                        })
                    }
                    else if (err && err.response && err.response.status && err.response.status === 422)
                        swal("اطلاعات ارسالی نادرست است.");
                    else if (err && err.response && err.response.status && err.response.status === 409) {
                        next(0, challengeId);
                    }
                    else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
                        swal(err.response.data.message.pr);
                    else swal("خطایی رخ داده است.")
                })
        } else {
            swal("برای شروع مسابقه، باید وارد شوید.").then(() => {
                localStorage.removeItem('token');
                props.history.push("/SignIn");
            })
        }
    }
    useEffect(() => {
        Axios.post(Config.api + "Challenge/GetChallenges", {
            "filter": ""
        },
            {
                headers: {
                    apikey: Config.apikey,
                    Authorization: "Bearer " + localStorage.getItem('token')

                }
            }).then(async (result) => {
                console.log(result)
                setChallenges(result.data.data);
            }).catch((err) => {
                if (err && err.response && err.response.status && err.response.status === 401) {
                    localStorage.removeItem('token');
                    props.history.push("/SignIn");
                }
                else if (err && err.response && err.response.status && err.response.status === 422)
                    swal("اطلاعات ارسالی نادرست است.");
                else if (err && err.response && err.response.status && err.response.status === 409) {
                    next(0);
                }
                else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
                    swal(err.response.data.message.pr);
                else swal("خطایی رخ داده است.")
            })
    }, []);
    return (
        <div>
            <Header
                color="transparent"
                brand="Material Kit React"
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 200,
                    color: "white"
                }}
                {...rest}
            />
            <Parallax small filter image={require("assets/img/bg16.jpg")} />
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div>
                    <div className={classes.container}>
                        <GridContainer justify="center" className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.topdev}>
                                    <div>
                                        <img src={"http://sharifcamp.ir/assets/images/ustmb.jpg"} alt="..." className={imageClasses} />
                                    </div>
                                    <div className={classes.name}>
                                        <h3 className={classes.title}>مسابقات برنامه نویسی آنلاین دانشگاه علوم و فنون مازندران</h3>
                                    </div>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                                    <GridItem xs={12} sm={12} md={4}>
                                        <Card className={classes.root + " " + classes.card} variant="outlined">
                                            <CardActionArea className={classes.cardMain}>
                                                <CardMedia
                                                    className={classes.media}
                                                    image={"http://sharifcamp.ir/assets/images/kooh.png"}
                                                    title="UstmbJam"
                                                />
                                                <CardContent>
                                                    <Typography gutterBottom variant="h6" component="h3">
                                                       فاتحان قله های علم
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary" component="p">
                                                       اولین دوره مسابقه برنامه نویسی، دی ماه
                                                    </Typography>
                                                </CardContent>
                                            </CardActionArea>
                                            <CardActions>
                                                <div className={classes.extra}>
                                                </div>
                                                <Button onClick={() => start("63962d4f69540000a4000c52", 5)} size="small" color="primary">
                                                    شروع
                                                </Button>
                                            </CardActions>
                                        </Card>
                                    </GridItem>
                        </GridContainer>
                        <br />
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h2>اهداف برگزاری</h2>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.topdev}>
                                    <p>
                                        <ul className={classes.rightToLeft}>
                                           <li>ایجاد فرصت لذت بردن در فرایندی که ترکیبی جذاب از آموزش و تجاری سازی و خلاقیت است.</li>
                                            <li>لذت حل مساله به شیوه‌های گوناگون در فرآیندی خلاقانه</li>
                                            <li>ایجاد خودباوری و اعتماد به نفس در دانشجویان</li>
                                            <li>آموزش رفتارهای صحیح اجتماعی -اقتصادی در حوزه کسب وکارهای نو</li>
                                            <li>پرورش ایده های  خلاقانه در حوزه برنامه نویسی</li>
                                            <li>توجه به رغبت‌ها و علایق متفاوت  دانشجویان</li>
                                            <li>شناسایی توانمندی‌ها و هدایت استعدادها در حوزه برنامه نویسی</li>
                                        </ul>
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer justify='center' className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h2>جوایز نفرات برتر</h2>
                            </GridItem>
                            <GridItem xs={6} sm={3} md={3}>
                                <div className={classes.center}>
                                    <img
                                        src={first}
                                        alt="..."
                                        className={classes.imgRounded + " " + classes.imgFluid + " " + classes.image}
                                    />
                                </div>
                                <div>
                                    <h4 className={classes.center}>نفر اول (مدال طلا)</h4>
                                    <p className={classes.justify}>
                                        نمره اضافه درس مبانی کامپیوتر و برنامه نویسی + گواهینامه نفر اول
                                    </p>
                                </div>
                            </GridItem>
                            <GridItem xs={6} sm={3} md={3}>
                                <div className={classes.center}>
                                    <img
                                        src={second}
                                        alt="..."
                                        className={classes.imgRounded + " " + classes.imgFluid + " " + classes.image}
                                    />
                                </div>
                                <div>
                                    <h4 className={classes.center}>نفر دوم (مدال نقره)</h4>
                                    <p className={classes.justify}>
                                    نمره اضافه درس مبانی کامپیوتر و برنامه نویسی + گواهینامه نفر دوم
                                    </p>
                                </div>
                            </GridItem>
                            <GridItem xs={6} sm={3} md={3}>
                                <div className={classes.center}>
                                    <img
                                        src={third}
                                        alt="..."
                                        className={classes.imgRounded + " " + classes.imgFluid + " " + classes.image}
                                    />
                                </div>
                                <div>
                                    <h4 className={classes.center}>نفر سوم (مدال برنز)</h4>
                                    <p className={classes.justify}>
                                    نمره اضافه درس مبانی کامپیوتر و برنامه نویسی + گواهینامه نفر سوم
                                    </p>
                                </div>
                            </GridItem>
                            <GridItem xs={6} sm={3} md={3}>
                                <div className={classes.center}>
                                    <img
                                        src={other}
                                        alt="..."
                                        className={classes.imgRounded + " " + classes.imgFluid + " " + classes.image}
                                    />
                                </div>
                                <div>
                                    <h4 className={classes.center}>نفرات 4م تا 10م</h4>
                                    <p className={classes.justify}>
                                    نمره اضافه درس مبانی کامپیوتر و برنامه نویسی
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
